<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Liquidadores</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Liquidadores</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables 
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    
    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarLiquidador"
      @ok="eliminarLiquidador();"
      @cancel="modalEliminarLiquidador = false"
    >¿Está seguro que quiere desactivar este liquidador?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarLiquidador"
      @ok="activarLiquidador();"
      @cancel="modalActivarLiquidador = false"
    >¿Está seguro que quiere activar este liquidador?</b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiLiquidadores from "@/components/services/apiLiquidadores";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";

export default {
  name: "Liquidadores",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      tieneAcceso: true,
      modalEliminarLiquidador: false,
      modalActivarLiquidador: false,
      selected: null,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      data: [],
      titles: [
        {
          prop: "correlativo",
          label: "#",
          align: "right",
          minwidth:'70'
        },
        {
          prop: "slicodigo",
          label: "SR",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "slinombre",
          label: "Nombre",
          align: "left",
          minwidth:'300'
        },
        {
          prop: "sliusumodif",
          label: "Usuario",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "slifmodif",
          label: "Fecha Modificación",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "desc_activo",
          label: "Estado",
          align: "left",
          minwidth:'100'
        }
      ],
      filters: [
        {
          prop: [
            "correlativo",
            "slicodigo",
            "slinombre",
            "sliusumodif",
            "slifmodif",
            "desc_activo"
          ],
          value: ""
        }
      ],

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400
      },
    };
  },
  methods: {
    
    customButtonsForRow(row) {
        if (row.sliactivo === 0) {
          return [
            {
              name: " Activar",
              icon: "fa fa-plus",
              type: "success",
              handler: _ => {
                this.$session.start();
                this.modalActivarLiquidador = true;
                this.selected = row.slicodigo;
              }
            }
          ];
        } else {
          return [
            {
              name: " Desactivar",
              icon: "fa fa-trash",
              type: "danger",
              handler: _ => {
                this.$session.start();
                this.modalEliminarLiquidador = true;
                this.selected = row.slicodigo;
              }
            }
          ];
        }
      
    },

    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];

      return apiLiquidadores
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
            this.buscar();
          }else{
            this.tieneAcceso = false;
          }
          
          this.datosFormularioEstado = response.data.festado;
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    
    buscar() {
      this.$Progress.start();

      return apiLiquidadores
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          "",
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "slifmodif" && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else {
        return row[column.property];
      }
    },

    eliminarLiquidador() {
      event.preventDefault();
      this.$Progress.start();
      return apiLiquidadores
        .eliminar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.selected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "slicodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar();
            this.modalEliminarLiquidador = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarLiquidador() {
      event.preventDefault();
      this.$Progress.start();
      return apiLiquidadores
        .activar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.selected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "slicodigo"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar();
            this.modalActivarLiquidador = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
